/**
 * `queueMicrotask` is not universal — some JavaScript engines React Native has shipped do
 * without it — and this code runs on phones, in browsers, and inside a Worker. Falling back
 * to a resolved promise keeps the same ordering guarantee everywhere.
 */
export function scheduleMicrotask(task: () => void): void {
  if (typeof queueMicrotask === 'function') queueMicrotask(task);
  else void Promise.resolve().then(task);
}
